// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://wmb-api.worldmetalbands.com',
  // BASE_URL: 'http://localhost:3000', // Pour les tests locaux
  API_KEY: 'gQ1K_!k2cKp_3O+_Ha4dvrc9-a653-4304-bb66-a8231%2C4%2C7b33745b863-17213379',
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000 // 1 second
};

// Category mapping from our app categories to API categories
export const CATEGORY_MAPPING = {
  'trending': 'trending',
  'popular': 'popular',
  'new-releases': 'new-releases',
  'my-list': 'my-list',
  'continue-watching': 'continue-watching',
  'featured': 'featured',
  'action': 'action',
  'comedy': 'comedy',
  'horror': 'horror',
  'drama': 'drama',
  'sci-fi': 'sci-fi',
  'documentary': 'documentary'
};

// Theme mapping to API parameters
export const THEME_MAPPING = {
  'rock': 'wmb',      // World Metal Bands
  'latino': 'latino', // Tropical/Latino music
  'standup': 'standup', // Stand-up comedy
  'culture_fr': 'culturefr', // Culture Française
  'spkombat': 'spkombat', // spkombat
  'sport': 'sport', // Sport videos
  'wildpeaks': 'wildpeaks' // Wild Peaks theme
};

// Default API parameters
export const DEFAULT_API_PARAMS = {
  limit: 20,
  offset: 0,
  search: '',
  label: '',
  orderfields: 'created',
  orderby: 'desc',
  t: 'wmb'
};

// Error messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  API_ERROR: 'API error. Please try again later.',
  NOT_FOUND: 'Content not found.',
  UNAUTHORIZED: 'Unauthorized access. Please check your API key.',
  RATE_LIMIT: 'Too many requests. Please wait and try again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  TIMEOUT: 'Request timeout. Please try again.',
  UNKNOWN: 'An unknown error occurred.'
};

// Cache configuration
export const CACHE_CONFIG = {
  TTL: 1 * 60 * 1000, // 5 minutes
  MAX_SIZE: 100, // Maximum number of cached items
  STORAGE_KEY: 'wmb_video_cache'
};

export default {
  API_CONFIG,
  CATEGORY_MAPPING,
  DEFAULT_API_PARAMS,
  ERROR_MESSAGES,
  CACHE_CONFIG
};
